export enum ApprovedTypesEnum {
  APPROVED = 'APPROVED',
  APPROVED_WITH_REMARK = 'APPROVED_WITH_REMARK',
  DENIED = 'DENIED',
  ON_APPROVAL = 'ON_APPROVAL',
  DENIED_PLANNED = 'DENIED_PLANNED',
}
